/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".level-1-round[_ngcontent-%COMP%]{width:2.5rem;height:2.5rem}.level-2-round[_ngcontent-%COMP%]{width:3.5rem;height:3.5rem}.level-3-round[_ngcontent-%COMP%]{width:4.5rem;height:4.5rem}.clip-text-break[_ngcontent-%COMP%]{text-overflow:ellipsis;overflow:hidden}.icon-placement[_ngcontent-%COMP%]{font-size:15px;position:relative;top:2px;left:5px}\n/*# sourceMappingURL=thumbnail-card.component.css.map*/"];
export { styles as styles };
